/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.mobile.init());


App.mobile = {

  init() {
    if (!$("body.phone").length) { return false; }

    $(document)
      .off("click", ".js-menu-trigger", App.mobile.menu_triggered)
      .on("click", ".js-menu-trigger", App.mobile.menu_triggered)

      .off("click", ".js-mobile-disclaimer-close", App.mobile.close_disclaimer)
      .on("click", ".js-mobile-disclaimer-close", App.mobile.close_disclaimer)

      .on("click", ".ttip-item", () => false);

    this.disclaimer_init();
    return this.message_init();
  },


  close_disclaimer(evt) {
    evt.preventDefault();
    $('.js-mobile-disclaimer').fadeOut();
    return localStorage.ts_disclaimer_closed = true;
  },


  disclaimer_init() {
    if (localStorage.ts_disclaimer_closed) {
      return $('.js-mobile-disclaimer').remove();
    }
  },


  menu_triggered(evt) {
    evt.preventDefault();
    return $("body").toggleClass("menu-active");
  },


  message_init() {
    if (!$(".js-msg-from-options").length) { return; }

    $(document)
      .off("change", ".js-msg-from-options", App.mobile.from_name_changed)
      .on("change", ".js-msg-from-options", App.mobile.from_name_changed)
      .off("submit", ".js-mobile-message-form", App.mobile.message_submitted)
      .on("submit", ".js-mobile-message-form", App.mobile.message_submitted);


    return App.mobile.set_initial_from_name();
  },

  // Lifted from message_modal_support
  // When the msg modal loads, prepend the last selected From name to the body
  set_initial_from_name: () => {
    const $msg_body = $(".js-form-message-body");

    const default_value = $(".js-msg-from-options").val();
    const last_value = Cookies.get("lsfn") || default_value;
    $(".js-msg-from-options").val(last_value);
    return App.mobile.set_from_name_in_message(last_value);
  },


  from_name_changed: evt => {
    const new_value = $(evt.target).val();
    return App.mobile.set_from_name_in_message(new_value);
  },


  message_submitted(evt) {
    return App.mobile.submit_disable();
  },


  submit_disable(evt) {
    return $('.js-mobile-message-submit').prop('disabled', true);
  },


  submit_enable(evt) {
    return $('.js-mobile-message-submit').prop('disabled', false);
  },


  // Lifted from message_modal_support
  // 1. Clear the old prepended value from body field if present
  // 2. Prepend the new value unless "[none]"
  // 3. Remember the new value
  set_from_name_in_message: new_value => {
    // console.log 'in set_from_name_in_message: ', new_value
    const $select = $(".js-msg-from-options");
    const $msg_body = $(".js-form-message-body");

    $.each($select[0].options, function() {
      const val = this.value;
      if (val !== "[none]") {
        const re = new RegExp(`^${val}`, "i");
        return $msg_body.val($msg_body.val().replace(re, ""));
      }
    });

    // Don't change in edit mode?
    if (new_value !== "[none]") {
      const orig_body = $msg_body.val();
      $msg_body.val(`${new_value}${orig_body}`);
    }

    $msg_body.change().focus();
    return Cookies.set("lsfn", new_value);
  }
};
